import { PageKeyMap } from '@/telemetry-sdk';

const pageKeyMap: PageKeyMap = {
  homepage: '/',
};
export { pageKeyMap };
